module.exports = __webpack_public_path__ + "static/img/benefit3.055472f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPage/bussiness/benefit3.png
// module id = BAEH
// module chunks = 30